import { render, staticRenderFns } from "./PendingDocumentsCreationStatusPage.vue?vue&type=template&id=fed7f5a4"
import script from "./PendingDocumentsCreationStatusPage.vue?vue&type=script&lang=ts"
export * from "./PendingDocumentsCreationStatusPage.vue?vue&type=script&lang=ts"
import style0 from "./PendingDocumentsCreationStatusPage.vue?vue&type=style&index=0&id=fed7f5a4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports